import { render, staticRenderFns } from "./LongCard.vue?vue&type=template&id=3a38c9c6&scoped=true&"
import script from "./LongCard.vue?vue&type=script&lang=js&"
export * from "./LongCard.vue?vue&type=script&lang=js&"
import style0 from "./LongCard.vue?vue&type=style&index=0&id=3a38c9c6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38c9c6",
  null
  
)

export default component.exports